import type { FC } from 'react';
import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import { cnSkeleton } from './Skeleton.cn';

import './Skeleton.css';

export interface ISkeletonProps extends IClassNameProps {
    type?: 'text' | 'control' | 'avatar';
    style?: React.CSSProperties;
    size?: 's' | 'm' | 'l';
    animation?: boolean;
}

const getDefaultSize = (type: ISkeletonProps['type']): ISkeletonProps['size'] => {
    switch (type) {
        case 'avatar':
            return 'l';
        case 'control':
            return 'm';
        default:
            return undefined;
    }
};

export const Skeleton: FC<ISkeletonProps> = (props) => {
    const {
        type = 'text',
        style,
        animation = true,
        size = getDefaultSize(type),
        className,
        ...restProps
    } = props;

    return (
        <div
            {...restProps}
            className={cnSkeleton({ type, size, animation }, [className])}
            style={style}
        />
    );
};
